import {Device} from '../../constants';
import styled from 'styled-components';

export default styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 9999;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;

  .overlay-wrapper {
    max-width: 800px;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;

    @media only screen and (max-height: 600px) {
      height: 100%;
    }

    .overlay-content-wrapper {
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 3rem;

      @media screen and ${Device.tablet} {
        gap: 1.5rem;
      }

      @media screen and ${Device.mobileL} {
        flex-direction: column;
      }
    }

    .overlay-content {
      min-height: 428px;
      display: inline-flex;
      border-radius: 0.75rem;
      text-align: center;
      background: linear-gradient(to right, #101014 38%, #3c3c3c 100%);
      padding: 3rem;

      @media screen and ${Device.tablet} {
        padding: 1.5rem;
      }

      .overlay-content-block {
        width: 100%;
        text-align: left;
        vertical-align: top;
        display: flex;
        flex-direction: column;
        gap: 1.5rem;

        @media screen and ${Device.tablet} {
          gap: 1rem;
        }

        @media screen and ${Device.mobileL} {
          text-align: center;
        }

        h1 {
          margin: 0;
          line-height: 1;
        }

        p {
          margin: 0;
          font-size: 1rem;
        }

        .overlay-content-block__redirecting-now {
          display: inline-flex;
          align-items: center;
          gap: 0.25rem;
          margin-left: -0.5rem;
          font-weight: bold;
          color: #ffff00;

          svg {
            scale: 0.625;

            path {
              stroke: #ffff00;
            }
          }

          @media screen and ${Device.mobileL} {
            justify-content: center;
          }
        }
      }

      img {
        width: 100%;
        display: block;
        margin-bottom: -5rem;
        @media screen and ${Device.mobileL} {
          margin-bottom: -4rem;
        }
      }
    }
  }
`;
